import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Grid, Row, Col} from 'react-bootstrap';
import {css} from 'aphrodite';
import {nodeId} from 'react-widgets/libs';

const Header = (props) => {
  const {
    settings,
    styleSheet,
    authenticated,
    logoAssets,
    handleLogout,
  } = props;

  const productLogo = <img src={logoAssets[settings.header.productLogo]} className={css(styleSheet.headerLogo)} alt={settings.content.productLogoAlt} />;

  const headerLinks = settings.header.links.map((link) => {
    // Relative links should be routed within reactrouter
    if (link.href.charAt(0) === '/') {
      return <Link key={nodeId()} to={link.href} className={css(styleSheet.headerLink, styleSheet.headerPageLink)}>{link.name}</Link>;
    }
    return <a key={nodeId()} className={css(styleSheet.headerLink)} href={link.href} target={link.newTab ? '_blank' : null}>{link.name}</a>;
  });

  const linkSectionGridWidth = 12 - settings.header.logoSectionGridWidth;

  return (
    <header data-component="Header" className={css(styleSheet.header)}>
      <Grid>
        <Row>
          <Col sm={settings.header.logoSectionGridWidth}>
            {settings.header.productLogo &&
              (settings.header.productLogoLink.charAt(0) === '/' ?
                <Link to={settings.header.productLogoLink}>{productLogo}</Link>
                :
                <a href={settings.header.productLogoLink}>{productLogo}</a>)
            }
          </Col>
          <Col sm={linkSectionGridWidth}>
            {authenticated
              && <a className={css(styleSheet.headerLink)} onClick={handleLogout}>Logout</a>}
            {headerLinks}
            <p className={'pull-right'}>{settings.content.headerUsageDisclaimer}</p>
          </Col>
        </Row>
      </Grid>
    </header>
  );
};

Header.protoTypes = {
  settings: PropTypes.object.isRequired,
  styleSheet: PropTypes.object.isRequired,
  logoAssets: PropTypes.object.isRequired,
  authenticated: PropTypes.bool,
  handleLogout: PropTypes.func.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx